module.exports = __webpack_public_path__ + "static/hymots-g-1-adf3e452950f50b6b491ff95e893da77.png";